<header class="headerSection">
        @if(contentHeader?.heading){
        <div [style]="'background-image:url('+ imgSrc +')'" [ngClass]="{'postEnroll' : csp.userIsEnrolled()}">
            <div class="text-container">
                @if(!isMobile){
                <ng-container [ngTemplateOutlet]="textContainer"></ng-container>
                }
                @if(contentHeader?.citiShoplogo){
                    <img class="citishop-logo" [src]="csp.imagePrefix() + contentHeader?.citiShoplogo" alt="Citi logo" />
                }
            </div>
        </div>
        @if(isMobile && !csp.userIsEnrolled()){
        <div class="line-divider text-container">
            <ng-container [ngTemplateOutlet]="textContainer"></ng-container>
            <p *ngIf="!csp.eanbleDownloadButton()" [innerHTML]="contentHeader?.mobileText"></p>
        </div>
        }    
    }
</header>

<ng-template #textContainer>
    <h1 [innerHTML]="(contentHeader?.heading || '') | safeHtml"></h1>
    <p [innerHTML]="(contentHeader?.subHeading || '') | safeHtml"></p>
    <app-citi-shop-add-to-browser-button *ngIf="!csp.userIsEnrolled() &&csp.eanbleDownloadButton()"         
    [buttonColor]="isMobile ? '' :'white'"
    [sectionName]="taggingSectionName" (buttonClicked)="buttonClicked($event)">
    </app-citi-shop-add-to-browser-button>
</ng-template>